// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
import { checkAccessRights } from '../utils/functions/accessRight';
import { ROLES } from '../utils/constants';
// Define a service using a base URL and expected endpoints

const USER = process.env.REACT_APP_API_URL;
const ADMIN = process.env.REACT_APP_API_URL_admin;

const baseQuery = fetchBaseQuery({
  baseUrl: `${
    checkAccessRights(ROLES.ADMIN_ROLE) ||
    checkAccessRights(ROLES.SUPER_ADMIN_ROLE) ||
     checkAccessRights(ROLES.SALE_ROLE)
      ? ADMIN
      : USER
  }/sale-order`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');

    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const invoiceListApi = createApi({
  reducerPath: 'invoiceListApi',
  baseQuery,
  endpoints: (builder) => ({
    getInvoiceList: builder.query({
      query: (q) =>
        `?customerCode=${q.customerCode}&sorgcode=${q.sorgcode}&paymentStatus=${q.paymentStatus}&paymentType=${q.paymentType}&soPaymentStatus=${q.soPaymentStatus}&startDate=${q.startDate}&endDate=${q.endDate}&search=${q.search}&hashTaxId=${q.hashTaxId}&federalTaxId=${q.federalTaxId}&quotation=${q.quotation}&page=${q.page}&size=${q.size}&sort=${q.sort}`,
    }),
    getInvoiceListAdmin: builder.query({
      query: (q) =>
        `?customerCode=${q.customerCode}&sorgcode=${q.sorgcode}&contractStatus=${q.contractStatus}&hashTaxId=${q.hashTaxId}`,
    }),
    getQuotationNO: builder.query({
      query: (q) =>
        `/quotation/?customerCode=${q.customerCode}&sorgcode=${q.sorgcode}&federalTaxId=${q.federalTaxId || ''}`,
    }),

    // ✅ เพิ่ม endpoint ใหม่ที่เป็น POST
    checkPeriod: builder.mutation({
      query: (payload) => ({
        url: '/check-period',
        method: 'POST',
        body: { invoiceList: payload },
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetInvoiceListQuery,
  useGetInvoiceListAdminQuery,
  useGetQuotationNOQuery,
  useCheckPeriodMutation,
} = invoiceListApi;
